import React from "react";

import { useTheme, useMediaQuery } from "@material-ui/core";
import Container from "@material-ui/core/Container";
import AddIcon from "@material-ui/icons/Add";
import SortIcon from "@material-ui/icons/Sort";

import RbActions from "components/RbActions";
import RbButtonAction from "components/RbButtonAction";
import RbFlexView from "components/RbFlexView";
import RbFlexViewItem from "components/RbFlexViewItem";
import RbHeader from "components/RbHeader";
import RbMenuAction from "components/RbMenuAction";
import RbScrollView from "components/RbScrollView";
import RbSearchAction from "components/RbSearchAction";
import useDebounce from "hooks/useDebounce";

import CarsContent from "./CarsContent";

const sortItems = [
  { label: "Model: A to Z", by: "model", order: "ASC" },
  { label: "Model: Z to A", by: "model", order: "DESC" },
  { label: "Price: Low to High", by: "price", order: "ASC" },
  { label: "Price: High to Low", by: "price", order: "DESC" },
  { label: "Year: Low to High", by: "year", order: "ASC" },
  { label: "Year: High to Low", by: "year", order: "DESC" },
];

function CarsScreen() {
  const theme = useTheme();

  const downSm = useMediaQuery(theme.breakpoints.down("sm"));

  const [sort, setSort] = React.useState(sortItems[0]);

  const [filter, setFilter] = React.useState("");

  const [newOpen, setNewOpen] = React.useState(false);

  const filterDelayed = useDebounce(filter, 300);

  const handleNew = React.useCallback(() => {
    setNewOpen(true);
  }, []);

  const handleCancelNew = React.useCallback(() => {
    setNewOpen(false);
  }, []);

  return (
    <RbFlexView>
      <RbFlexViewItem>
        <RbHeader
          title="Cars"
          actions={
            <RbActions compacted={downSm}>
              <RbSearchAction
                value={filter}
                onChangeValue={setFilter}
                placeholder="Search"
              />
              <RbMenuAction
                Icon={SortIcon}
                text="Sort by"
                items={sortItems}
                selectedItem={sort}
                onSelect={setSort}
              />
              <RbButtonAction Icon={AddIcon} onClick={handleNew} text="New" />
            </RbActions>
          }
        />
      </RbFlexViewItem>
      <RbFlexViewItem
        flex="1"
        bgcolor="custom.bg.100"
        borderTop={1}
        borderColor="custom.border.200"
      >
        <RbScrollView py={2}>
          <Container>
            <CarsContent
              filter={filterDelayed}
              sort={sort}
              newOpen={newOpen}
              onCancelNew={handleCancelNew}
            />
          </Container>
        </RbScrollView>
      </RbFlexViewItem>
    </RbFlexView>
  );
}

export default React.memo(CarsScreen);
